import * as keycloakRoles from './keycloakRoles.js';
import * as seletores from './seletores.js';

export const getSeletoresByConfig = config => {
  return config.isCloud ? keycloakRoles : seletores;
};
